/**
 * Free Text Search View
 * @author hvillarreal
 *
 */
import $ from 'jquery';
import BaseView from 'BaseView';

const KeyCode = {
	RETURN: 13
};

export default BaseView.extend({
	el: '.js_freeTextSearch',

	events: {
		'keyup .js_filters-control-freeTextSearch': 'handleFreeTextSearchInput', // Handle inputs to free text search
		'click .js_submitSearch': 'triggerSearch', // Handle mouse click on search button
		'click .js_freeTextSearch-remove': 'removeFreeTextSearch'
	},

	initialize(options) {
		// get visibility of our parent (filter view) so we can have access to
		// 'onFilterView' since we rely on it heavily
		this.filterView = options.parent;

		this.render();
	},

	triggerSearch(event) {
		let searchTerm = this.$('.js_filters-control-freeTextSearch').val();
		if (searchTerm) {
			this.filterView.onFilterView(event);
		}
	},

	/**
	 * clears free text search from UI and model
	 */
	clearFreeTextSearch (event) {
		$('.js_freeTextSearch').removeClass('filter-search-hasValue');
		this.$('.js_filters-control-freeTextSearch').val('');

		this.model.set('isClearFreeTextSearch', true);
		this.model.set('isClientSideFiltering', true);
		this.model.unset('freeTextSearch');
	},

	/**
	 * Clears free text search from UI and model
	 * and retriggers search with no free text search
	 */
	removeFreeTextSearch (event) {
		this.clearFreeTextSearch(event);
		this.filterView.onFilterView(event);
	},

	/**
	 * Unset free text search.
	 * Bring back previous view when user removes search term.
	 */
	handleFreeTextSearchInput (event) {
		if (($(event.target).val()) === '') {
			$('.js_freeTextSearch').removeClass('filter-search-hasValue');
			this.model.set('isClearFreeTextSearch', true);
			this.model.set('isClientSideFiltering', true);

			if (this.model.has('freeTextSearch')) {
				this.model.unset('freeTextSearch');
			}

			this.filterView.onFilterView(event);
		} else {
			$('.js_freeTextSearch').addClass('filter-search-hasValue');
			if (event.which === KeyCode.RETURN) {
				this.filterView.onFilterView(event);
			}
		}
	},

	/**
	 * Persist the free text search input to the model
	 * This is tied to keyup event on search text.
	 */
	updateFreeTextSearch () {
		let searchTerm = this.$('.js_filters-control-freeTextSearch').val();
		if (searchTerm) {
			this.model.set('freeTextSearch', searchTerm.trim());
			this.model.set('isClientSideFiltering', true);
			this.model.set('isClearFreeTextSearch', false);
			this.model.triggerSearchFPTI();
		}
	},
});



// WEBPACK FOOTER //
// ./view/activity/filters/freeTextSearchView.es6